
import { defineComponent } from 'vue'
import { ITrigger } from '../../../Workspace'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import workspaceSchedulationSchedulationsTableDescriptor from './WorkspaceSchedulationSchedulationsTableDescriptor.json'
import { mapState } from 'vuex'
export default defineComponent({
    name: 'workspace-schedulation-schedulations-list',
    components: { Checkbox, Column, DataTable },
    props: { triggers: { type: Array }, index: { type: Number }, propSelectedSchedulations: { type: Object } },
    emits: ['runSchedulationClick', 'selectedSchedulations'],
    data() {
        return {
            workspaceSchedulationSchedulationsTableDescriptor,
            schedulations: [] as ITrigger[],
            selectedSchedulations: [] as ITrigger[]
        }
    },
    computed: {
        ...mapState({
            user: 'user'
        }),
        canRunScheduledExecutions(): any {
            return this.user.functionalities.includes('RunSnapshotsFunctionality')
        }
    },
    watch: {
        triggers() {
            this.loadSchedulations()
        },
        propSelectedSchedulations: {
            handler() {
                this.loadSelectedSchedulations()
            },
            deep: true
        }
    },
    created() {
        this.loadSchedulations()
        this.loadSelectedSchedulations()
    },
    methods: {
        loadSchedulations() {
            this.schedulations = this.triggers as ITrigger[]
        },
        loadSelectedSchedulations() {
            this.selectedSchedulations = this.propSelectedSchedulations?.[this.index as number] as any
        },
        runSchedulation(schedulation: ITrigger) {
            this.$emit('runSchedulationClick', schedulation)
        },
        setSelectedSchedulations() {
            this.$emit('selectedSchedulations', { index: this.index, schedulations: this.selectedSchedulations })
        }
    }
})
